import { render, staticRenderFns } from "./ConfirmDeviceProblemsList.vue?vue&type=template&id=9aff8f4e&"
import script from "./ConfirmDeviceProblemsList.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeviceProblemsList.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDeviceProblemsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports